import gql from 'graphql-tag';

export default gql`
  mutation softDeleteChannelIntegration($id: UUID!) {
    softDeleteChannelIntegration(_id: $id)
  }
`;
